<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    provide() {
        return {
            reload: this.reload
        }
    },
    data() {
        return {
            isRefresh: true
        }
    },
    mounted() {},
    methods: {
        reload() {
            this.isRefresh = false;
            this.$nextTick(() => {
                this.isRefresh = true
            })
        },
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue